export function getImageSrc(imagen?: string | string[] | null): string {
  if (!imagen) {
    return "";
  }

  const rawImage = Array.isArray(imagen) ? imagen[0] : imagen;

  if (!rawImage || typeof rawImage !== "string") {
    return "";
  }

  // Si ya es una URL absoluta (http, https, //, data:)
  if (/^(https?:)?\/\//i.test(rawImage) || rawImage.startsWith("data:")) {
    return rawImage;
  }

  const base = (import.meta.env.VITE_API_URL ?? "").replace(/\/$/, "");

  return `${base}${rawImage.startsWith("/") ? "" : "/"}${rawImage}`;
}

